/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import App from './components/App';
import Notification from './components/CustomComponents/Notification';
import ErrorBoundary from './components/ErrorBoundary';
import store from './store';
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'

require('./bootstrap');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/App');

!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error('Segment snippet included twice.');else{analytics.invoked=!0;analytics.methods=['trackSubmit','trackClick','trackLink','trackForm','pageview','identify','reset','group','track','ready','alias','debug','page','once','off','on','addSourceMiddleware','addIntegrationMiddleware','setAnonymousId','addDestinationMiddleware'];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement('script');t.type='text/javascript';t.async=!0;t.src='https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';var n=document.getElementsByTagName('script')[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey='MTF4GmoEHiOlkBrHMzAARXW6YYUsNdL4';analytics.SNIPPET_VERSION='4.15.3';
    analytics.load(process.env.SEGMENT_TOKEN);
    analytics.page();
}}();

const container = document.getElementById('app');
const root = createRoot(container); 

const originalRemoveItem = localStorage.removeItem.bind(localStorage);
localStorage.removeItem = function(key) {
    if (key === 'dashboardToken') {
        console.warn('[localStorage] localStorage dashboardToken REMOVED:', {
            stack: (new Error()).stack,
        });
    }
    return originalRemoveItem(key);
}

root.render(    
    <ErrorBoundary>
        <BrowserRouter>
            <Provider store={store}>
                <App />
                <Notification />
            </Provider>
        </BrowserRouter>
    </ErrorBoundary>);
